import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const FragorSvar = lazy(() => import("@/pages/info/FragorSvar"));

export const Route = createFileRoute("/fragor-svar")({
  head: () => seoHead("/fragor-svar", { description: "De vanligaste frågorna vi får om elavtal, elpriser och bytesprocessen." }),
  component: () => <FragorSvar />,
});
